import { render } from "./FormContato.vue?vue&type=template&id=b3b2ee8c&lang=pug"
import script from "./FormContato.vue?vue&type=script&setup=true&lang=js"
export * from "./FormContato.vue?vue&type=script&setup=true&lang=js"

import "./FormContato.vue?vue&type=style&index=0&id=b3b2ee8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__